export type milliseconds = number;
export const secondMs: milliseconds = 1000;
export const minuteMs: milliseconds = secondMs * 60;
export const hourMs: milliseconds = minuteMs * 60;
export const dayMs: milliseconds = hourMs * 24;
export const weekMs: milliseconds = dayMs * 7;
